import { connectionRequestFactory } from "@ihr-radioedit/gql-client";
import { Connection, ConnectionConfig } from "@ihr-radioedit/sdk-network";
import { environ } from "@ihr-radioedit/sdk-utils";
import { getSdk } from "../generated/webapi.g";

export const sdk = (() => {
    const options: ConnectionConfig = {
        baseURL: `${environ.get("PROTOCOL", "https")}://${environ.dep("webapi")}/graphql`,
        timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
    };
    if (environ.get("DEBUG", "0") === "1") {
        options.headers = { "fastly-debug": 1 };
    }
    const client = new Connection(options);
    const requestFactory = connectionRequestFactory(client);
    return getSdk(requestFactory);
})();
